import MetricInterfaceCollection from 'app/stores/metrics/MetricInterfaceCollection';
import MetricInterfaceModel from 'app/stores/metrics/MetricInterfaceModel';

export const metricsInterfaces = new MetricInterfaceCollection();
// not strictly necessary to do this asynchronously but it can help
import('app/$store').then(({ default: store }) => store.registerCollection('metricsInterfaces', metricsInterfaces));

export const fetchMetricsInterface = (interfaceIdOrModel: string | MetricInterfaceModel) => {
  const intf =
    interfaceIdOrModel instanceof MetricInterfaceModel
      ? interfaceIdOrModel
      : new MetricInterfaceModel({ id: interfaceIdOrModel });

  return intf.fetch().then(() => intf);
};
